import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

function getVisitorId() {
  let id = localStorage.getItem("yws_visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("yws_visitor_id", id);
  }
  return id;
}

export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    if (location.pathname.startsWith("/admin") || lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    api.post("/analytics/event", { type: "pageview", visitor_id: getVisitorId(), path: location.pathname }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest("[data-testid]");
      if (!el || window.location.pathname.startsWith("/admin")) return;
      api.post("/analytics/event", {
        type: "click",
        visitor_id: getVisitorId(),
        label: el.dataset.testid,
        path: window.location.pathname,
      }).catch(() => {});
    };
    document.addEventListener("click", onClick, { passive: true });
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
}
